__turbopack_context__.v({
  "form-input": "form-input-module-scss-module__OASgtW__form-input",
  "form-input--has-error": "form-input-module-scss-module__OASgtW__form-input--has-error",
  "form-input--has-value": "form-input-module-scss-module__OASgtW__form-input--has-value",
});
